/* Approved legal drafts, adapted to the actual Phase 1 implementation.
   Marked as pending final review against the live site before launch. */

const REVIEW_NOTE =
    "This policy is a Phase 1 draft and requires final review against the live website before launch.";

export const LEGAL_PAGES = {
    privacy: {
        slug: "privacy-policy",
        title: "Privacy Policy",
        updated: "Pending final review before launch",
        reviewNote: REVIEW_NOTE,
        sections: [
            {
                h: "1. Who we are",
                body: [
                    "This website is operated for Dasamahavidya Puja by Chetla Sarbasadharaner Kali Puja Trust (“the Trust”, “we”, “us” or “our”). The website shares information about the Puja, its traditions, cultural programmes, community initiatives and ways to contact the organising committee.",
                    "Privacy contact: dasamahavidya.chetla@gmail.com. Public address: 78B, Peary Mohan Roy Road, Kolkata – 700027, Chetla, Kolkata, West Bengal, India.",
                ],
            },
            {
                h: "2. Information this website may collect",
                body: [
                    "The information collected depends on the features enabled on the live website. We may receive:",
                ],
                list: [
                    "Information you choose to submit, such as your name, email address, phone number, organisation, the subject of your enquiry and the message you send.",
                    "Information contained in correspondence you send to the official committee email or phone number.",
                    "Basic technical and usage information that may be recorded by the website host or security services, such as IP address, browser type, device information, date/time of access, pages requested and error/security logs.",
                    "Information related to an event, cultural-participation or partnership enquiry, if you voluntarily provide it.",
                    "Cookie or similar technology information, but only to the extent these tools are present on the live website. See the Cookie Policy.",
                ],
                after: [
                    "Please do not submit passwords, bank-account credentials, payment-card details, government identity documents, health information or other sensitive personal information through a general contact form or ordinary email. The Trust does not need such information for a normal website enquiry.",
                ],
            },
            {
                h: "3. How we use information",
                body: [
                    "We use information for purposes connected with operating the website and responding to the reason you contacted us, including to:",
                ],
                list: [
                    "reply to questions about the Puja, rituals, cultural programmes and community activities;",
                    "respond to partnership, sponsorship, volunteer, performer or media enquiries;",
                    "administer a request you have made and communicate any necessary follow-up;",
                    "maintain website security, prevent spam or misuse, troubleshoot errors and understand basic site performance where analytics are enabled;",
                    "maintain records that are reasonably necessary for committee administration and to meet applicable legal obligations.",
                ],
                after: [
                    "We will not use contact details collected for a particular enquiry to send unrelated promotional messages unless there is an appropriate basis and, where required, your consent. We do not sell personal information to third parties.",
                ],
            },
            {
                h: "4. How we share information",
                body: [
                    "Access is limited to committee members who need the information to respond to an enquiry or manage the relevant activity. Where used, we may share necessary information with service providers that host the website, deliver email, manage a form, protect the site from spam or provide analytics. Those providers may process information under their own terms and privacy documentation.",
                    "We may also disclose information when required by law, a lawful request from a competent authority, or when reasonably necessary to protect the rights, safety and security of people or the website. We do not authorise service providers to use enquiry information for their own unrelated marketing.",
                ],
            },
            {
                h: "5. Cookies and third-party services",
                body: [
                    "The site may use essential cookies or similar technologies supplied by the website platform. This Phase 1 website does not include analytics, maps, video embeds, social widgets, advertising pixels or other optional third-party features. If such features are added later, those services may collect information or set their own cookies subject to their configurations and policies, and this Policy and the Cookie Policy will be updated to describe the actual tools before they are enabled.",
                ],
            },
            {
                h: "6. Children's information",
                body: [
                    "The site is not intended to collect children's personal information unnecessarily. If a child is participating in a competition or programme and the committee needs information to administer that participation, a parent or legal guardian should provide the information or supervise the submission. Do not upload children's photographs, contact details or other identifying information unless the appropriate permission has been obtained. The committee uses a separate, clear permission process for identifiable publicity photographs of children.",
                ],
            },
            {
                h: "7. Security and retention",
                body: [
                    "We take reasonable steps appropriate to the website's size and the type of information involved to restrict access and protect information from unauthorised use or disclosure. No website, email service or online transmission can be guaranteed completely secure.",
                    "We keep personal information only for as long as reasonably necessary to respond to the enquiry, administer the relevant activity, maintain appropriate records, resolve disputes or comply with applicable requirements. Retention periods depend on the type of record and the reason it was collected.",
                ],
            },
            {
                h: "8. Your requests and choices",
                body: [
                    "You may contact us to ask about personal information you have submitted, request a correction, ask that information no longer be used for a particular optional purpose, or withdraw a consent where processing relies on consent and withdrawal is available. We may need to retain some information where required for lawful purposes. Send your request to dasamahavidya.chetla@gmail.com and explain the enquiry or record involved. We may ask for proportionate information to verify the request.",
                    "Applicable rights and procedures may depend on the law in force and the way the website is used. This Policy will be updated as applicable data-protection requirements and the website's features change.",
                ],
            },
            {
                h: "9. Links to other websites",
                body: [
                    "This website may link to external websites and social-media pages. We do not control their content, security or privacy practices. Review the relevant provider's policy before submitting information to it.",
                ],
            },
            {
                h: "10. Changes to this Policy",
                body: [
                    "We may revise this Policy when the website or our practices change. The current version will be posted on this page with its updated date. A change to the Policy does not, by itself, expand the purposes for which we may lawfully use information already collected.",
                ],
            },
            {
                h: "11. Contact",
                body: [
                    "For questions or privacy requests, contact: dasamahavidya.chetla@gmail.com • 78B, Peary Mohan Roy Road, Kolkata – 700027.",
                ],
            },
        ],
    },
    cookies: {
        slug: "cookie-policy",
        title: "Cookie Policy",
        updated: "Pending final review before launch",
        reviewNote: REVIEW_NOTE,
        sections: [
            {
                h: "1. What cookies are",
                body: [
                    "Cookies are small text files or similar technologies that a website or service may store on your browser or device. They can help a site work, remember settings, measure usage or enable embedded content. The word “cookies” in this Policy also includes similar technologies where relevant.",
                ],
            },
            {
                h: "2. What this website uses",
                body: [
                    "This website is a static, informational site. It does not use analytics, advertising, marketing or social-media cookies, and it does not embed third-party content such as videos or maps. Only cookies or similar storage that are strictly necessary for the website platform to operate and stay secure may be present.",
                    "In addition, your own cookie preference — the choice you make in the consent notice — is stored in your browser's local storage so that the notice does not reappear on every visit. This record stays on your device and is not transmitted to us.",
                    "If optional features are added in the future, this Policy will be updated to list the actual cookie names, providers, purposes and durations before those features are enabled.",
                ],
                list: [
                    "Strictly necessary — core site functions and security (platform-supplied only).",
                    "Consent preference — remembers your cookie choice, stored in your own browser.",
                    "Preferences, analytics, embedded content and advertising categories — not currently in use on this website.",
                ],
            },
            {
                h: "3. Consent and choices",
                body: [
                    "Because this website does not currently use optional analytics, advertising or similar technologies, the consent notice simply records your acknowledgement. You can revisit your choice at any time through the “Cookie Settings” link in the website footer, or clear it by deleting this site's data in your browser settings.",
                    "You can control or delete cookies through your browser settings, though browser controls may not block every form of third-party collection.",
                ],
            },
            {
                h: "4. Third-party providers",
                body: [
                    "No embedded videos, maps, social widgets, analytics or form providers are installed on this Phase 1 website. This section will name any third-party service actually installed before it goes live.",
                ],
            },
            {
                h: "5. Policy changes and contact",
                body: [
                    "We may update this Policy when the website changes. For questions, contact dasamahavidya.chetla@gmail.com.",
                ],
            },
        ],
    },
    terms: {
        slug: "terms-of-use",
        title: "Website Terms of Use",
        updated: "Pending final review before launch",
        reviewNote: REVIEW_NOTE,
        sections: [
            {
                h: "1. About these terms",
                body: [
                    "This website is operated for Dasamahavidya Puja by Chetla Sarbasadharaner Kali Puja Trust (“the Trust”, “we”, “us” or “our”). By accessing or using the website, you agree to use it in accordance with these Terms. If you do not agree, please stop using the website.",
                ],
            },
            {
                h: "2. What the website is for",
                body: [
                    "The website provides general information about the Trust's Puja traditions, programme announcements, cultural and community activities, media features and contact routes. It may be updated, corrected or changed as annual arrangements are confirmed.",
                ],
            },
            {
                h: "3. Accuracy and programme changes",
                body: [
                    "We take care to publish information in good faith, but event dates, timings, artist participation, ritual arrangements, venue access and programme details can change. Please check the latest official announcement or contact the committee before relying on a time-sensitive detail. Historical and religious summaries are educational introductions; they are not ritual instructions and do not replace guidance from the officiating priests or the relevant tradition.",
                ],
            },
            {
                h: "4. Acceptable use",
                body: [
                    "You may browse the website and share links for lawful, non-misleading purposes. You must not attempt to disrupt or damage the website, bypass security controls, submit malicious code or spam, impersonate the Trust, misuse contact details, infringe another person's rights, or use website content in a way that is unlawful or misleading.",
                ],
            },
            {
                h: "5. Copyright, photographs and marks",
                body: [
                    "Unless an item is expressly identified otherwise, website text and original materials prepared for the Trust are intended for the Trust's use. Photographs, artwork, logos, music, video, news extracts and other materials may belong to the Trust, an individual creator, a publication or another rights holder. Do not reproduce or commercially reuse materials unless you have permission or a legal right to do so. Attribution alone does not always replace permission. Contact dasamahavidya.chetla@gmail.com for a rights enquiry.",
                ],
            },
            {
                h: "6. External links",
                body: [
                    "The website may link to third-party websites, publications, social networks or media coverage for convenience and context. We do not control those sites and are not responsible for their content, availability, security or privacy practices. An external link is not necessarily an endorsement.",
                ],
            },
            {
                h: "7. Enquiries, sponsorships and contributions",
                body: [
                    "Submitting an enquiry through the site does not by itself create a sponsorship agreement, event booking, donation receipt, partnership, volunteer appointment or commitment by the Trust. Any sponsorship or other formal arrangement is subject to confirmation by an authorised committee representative and, where appropriate, separate written terms.",
                    "Unless and until an official donation or payment mechanism is published, do not assume that the website itself accepts payments. If contribution details are shared through an official channel, independently confirm the recipient and instructions with the committee before transferring money. Do not send cash or payment to an individual or account based only on an unverified message or impersonating profile. Receipts and acknowledgements are subject to the Trust's actual accounting process and applicable rules.",
                ],
            },
            {
                h: "8. Privacy",
                body: [
                    "Use of personal information is described in the Privacy Policy. The Cookie Policy explains cookies and similar technologies used by the live site. Those pages are kept consistent with the services actually enabled.",
                ],
            },
            {
                h: "9. Availability and limitation",
                body: [
                    "We may suspend, update or discontinue all or part of the website for maintenance, security or operational reasons. The website is provided for general information. To the extent permitted by law, we do not guarantee that it will always be uninterrupted, error-free or available from every device. Nothing in these Terms excludes or limits liability that cannot lawfully be excluded or limited.",
                ],
            },
            {
                h: "10. Changes to these Terms",
                body: [
                    "We may update these Terms as the website evolves. The revised version will be posted here with an updated date. Continued use after a revision means you accept the revised Terms to the extent permitted by applicable law.",
                ],
            },
            {
                h: "11. Governing law and contact",
                body: [
                    "These Terms are intended to be governed by the laws applicable in India. For questions about these Terms, contact dasamahavidya.chetla@gmail.com.",
                ],
            },
        ],
    },
    photography: {
        slug: "photography-notice",
        title: "Event Photography Notice",
        updated: "Pending final review before launch",
        reviewNote: REVIEW_NOTE,
        sections: [
            {
                h: "Photography, video and event images",
                body: [
                    "Photography and video recording may take place at the Puja and associated public cultural programmes for event documentation, archival purposes and communication about the celebration. Selected images may appear on the Trust's official website, social-media pages, reports or future event materials.",
                    "We aim to treat visitors and participants respectfully. If you have a concern about an identifiable image published by the Trust, please contact dasamahavidya.chetla@gmail.com and include the image link or a description of where it appears. We will review the request and respond as soon as practicable, taking into account privacy, safety, legal obligations and the context in which the image was captured.",
                    "For children's competitions or identifiable close-up portraits of children, the committee uses a separate, clear permission process from the parent or legal guardian before using the image for promotional purposes. Participation in a public event should not be treated as unlimited permission to use every person's image in every context.",
                ],
            },
        ],
    },
};
